import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BackToStreamButton from '../../../Duperbrowse/BackToStreamButton';
import Details from '../../../DeviationViews/Details';
import Sidebar from '../../../Sidebar';
import ActionBar from '../../../ActionBar';
import ArtStage from '../../../ArtStage';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { isExtendedDeviationFullyLoaded } from '../../redux/helpers';
import Comments from '../Comments';
import CentralColumn from '../CentralColumn';
import s from './SimplePage.scss';
export const SimplePage = ({ deviation, withoutSidebar })=>{
    const withSidebar = !withoutSidebar;
    const isMobile = useContext(MobileContext);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const { needsSubscription } = useSubscriptionTier(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], withSidebar && !isMobile && s['sidebar'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['left-column'], s['stage'])
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(BackToStreamButton, null), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(Details, {
        deviation: deviation
    }))), withSidebar && !isMobile && /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation,
        className: s['right-column']
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['left-column'], s['meta'])
    }, /*#__PURE__*/ React.createElement(CentralColumn, {
        supportSidebar: withSidebar
    }, !needsSubscription && isExtendedLoaded && /*#__PURE__*/ React.createElement(Comments, {
        deviation: deviation,
        className: s['comments']
    }), !needsSubscription && !isExtendedLoaded && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['lloader'],
        view: "llama"
    }))), withSidebar && isMobile && /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation,
        className: s['right-column']
    }), withSidebar && /*#__PURE__*/ React.createElement("div", {
        className: s['clear']
    }));
};
SimplePage.displayName = 'SimplePage';
export default SimplePage;

//# sourceMappingURL=SimplePage.js.map